module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.page.ShopPages.items), function(page) {
    return _c('div', {
      staticClass: "uk-card uk-card-default uk-card-small uk-grid-collapse uk-child-width-1-2@s uk-margin",
      attrs: {
        "uk-grid": ""
      }
    }, [_c('div', {
      staticClass: "uk-card-media-left uk-cover-container"
    }, [(page.Asset.id) ? _c('img', {
      attrs: {
        "src": page.Asset.src,
        "alt": page.Asset.description,
        "uk-cover": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('canvas', {
      attrs: {
        "width": "1800",
        "height": "1200"
      }
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "uk-card-body"
    }, [_c('article', {
      staticClass: "uk-article"
    }, [_c('a', {
      staticClass: "uk-h2",
      attrs: {
        "href": page.ShopPage.href
      }
    }, [_vm._v(_vm._s(page.ShopPage.name))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(page.ShopPage.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uk-grid-small",
      attrs: {
        "uk-grid": ""
      }
    }, [_c('div', [_c('a', {
      staticClass: "uk-button uk-button-text",
      attrs: {
        "href": page.ShopPage.href
      }
    }, [_vm._v("Перейти")])])])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-498b774c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Search/SearchShopPages.vue
// module id = 114
// module chunks = 0